export default __webpack_public_path__ + "static/media/newsletter-outline-16px.ff92a9fe.svg";